export default __webpack_public_path__ + "static/media/location.179c0cd6.png";